import { MoreHoriz as OptionsIcon } from '@mui/icons-material';
import useRandomizedId from '@/lib/utils/useRandomizedId';
import { useState } from 'react';
import MenuWithLazyPersistedMounting from '@/components/Menu/MenuWithLazyPersistedMounting';
import DeleteThumbnail from './DeleteThumbnail';
import ControlsButton from './ControlsButton';
import clsx from 'clsx';
import UploadThumbnail from '../../UploadThumbnail';
import { Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import useForceStateUpdate from '@/lib/utils/useForceStateUpdate';

const ThumbnailControls = () => {
  const buttonId = useRandomizedId('thumbnail-controls-button');
  const menuId = useRandomizedId('thumbnail-controls-menu');

  const [menuAnchorElement, setMenuAnchorElement] =
    useState<HTMLButtonElement | null>(null);
  const menuOpen = menuAnchorElement !== null;

  const openMenu = (e: React.MouseEvent<HTMLButtonElement>): void => {
    setMenuAnchorElement(e.currentTarget);
  };

  const closeMenu = (): void => {
    setMenuAnchorElement(null);
  };

  const forceStateUpdate = useForceStateUpdate();

  return (
    <>
      <Tooltip
        title={
          <FormattedMessage id="portfolio.challenge.thumbnail_header.controls.button_tooltip" />
        }
      >
        <ControlsButton
          id={buttonId}
          className={clsx('thumbnail-controls-button', menuOpen && 'menu-open')}
          onClick={openMenu}
          aria-controls={menuOpen ? menuId : undefined}
          aria-expanded={menuOpen ? 'true' : undefined}
          aria-haspopup
        >
          <OptionsIcon />
        </ControlsButton>
      </Tooltip>
      <MenuWithLazyPersistedMounting
        id={menuId}
        labelledById={buttonId}
        anchorEl={menuAnchorElement}
        open={menuOpen}
        onClose={closeMenu}
      >
        <UploadThumbnail
          variant="edit"
          onForceMenuStateUpdate={forceStateUpdate}
        />
        <DeleteThumbnail />
      </MenuWithLazyPersistedMounting>
    </>
  );
};

export default ThumbnailControls;
